import { useEffect } from "react";

interface SeoMeta {
  title: string;
  description: string;
  keywords?: string;
}

function setMeta(name: string, content: string, isProp = false) {
  const attr = isProp ? "property" : "name";
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function useSeo(meta: SeoMeta) {
  useEffect(() => {
    if (meta.title) {
      document.title = meta.title;
    }
    if (meta.description) {
      setMeta("description", meta.description);
    }
    if (meta.keywords) {
      setMeta("keywords", meta.keywords);
    }
    const canonical = window.location.origin + window.location.pathname;
    let link = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonical);
    setMeta("og:title", meta.title, true);
    setMeta("og:description", meta.description, true);
    setMeta("og:url", canonical, true);
    setMeta("twitter:title", meta.title);
    setMeta("twitter:description", meta.description);
  }, [meta.title, meta.description, meta.keywords]);
}

export function useLdJson(ld: object | object[], id: string) {
  useEffect(() => {
    const old = document.getElementById(id);
    if (old) {
      old.remove();
    }
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = id;
    script.textContent = JSON.stringify(ld);
    document.head.appendChild(script);
    return () => {
      const cur = document.getElementById(id);
      if (cur) {
        cur.remove();
      }
    };
  }, [id, JSON.stringify(ld)]);
}

export function formatNum(n: number): string {
  if (n >= 10000) {
    return `${(n / 10000).toFixed(1).replace(/\.0$/, "")}w`;
  }
  return `${n}`;
}

export function formatDate(d: string): string {
  const [, m, day] = d.split("-");
  return `${Number(m)}月${Number(day)}日`;
}

export const siteName = "每日新瓜网";
export const siteSlogan = "扒开人设，看清真相";